import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import {
  ServicesSubSectionContainer,
  ServicesSubSectionHeader,
  ServicesSubSectionMainContent,
  ServicesSubSectionTitle,
  ServicesSubSectionValue,
} from '../../services/services-subsection/services-subsection.styles';
import {
  ItemName,
  ItemRow,
  Items,
  List,
} from './parcel-content-summary.styles';
import { useStore } from '../../../stores/store';
import { getFormattedPrice } from '../../../utils/price/get-formatted-price';
import { getAdditionalFieldTransKey } from '../parcel-items-management/configs/additional-fields.config';

const ParcelContentSummary = () => {
  const {
    parcelCreationStore: { shipment },
    userStore: { getCurrencySymbol },
  } = useStore();
  const { t } = useTranslation();

  if (shipment?.items?.length === 0) return null;

  return (
    <ServicesSubSectionContainer>
      <ServicesSubSectionHeader>{t('parcel_content')}</ServicesSubSectionHeader>
      <ServicesSubSectionMainContent>
        {shipment!.items!.map((item) => (
          <List key={item.id}>
            <ItemName>{item.description_standart}</ItemName>
            <Items>
              <ItemRow>
                <ServicesSubSectionTitle>
                  {t('quantity')}
                </ServicesSubSectionTitle>
                <ServicesSubSectionValue>
                  {item.number_of_items}
                </ServicesSubSectionValue>
              </ItemRow>
              <ItemRow>
                <ServicesSubSectionTitle>
                  {t('declared_value')}
                </ServicesSubSectionTitle>
                <ServicesSubSectionValue>
                  {getFormattedPrice(
                    item?.value,
                    getCurrencySymbol(shipment?.converted_price?.currency)
                  )}
                </ServicesSubSectionValue>
              </ItemRow>
              {item.additional_fields &&
                Object.entries(item.additional_fields)
                  .filter(([, fieldValue]) => !!fieldValue?.at(0))
                  .map(([fieldName, fieldValue]) => (
                    <ItemRow>
                      <ServicesSubSectionTitle>
                        {t(getAdditionalFieldTransKey(fieldName))}
                      </ServicesSubSectionTitle>
                      <ServicesSubSectionValue>
                        {fieldValue.at(0)}
                      </ServicesSubSectionValue>
                    </ItemRow>
                  ))}
              {item.description_free && (
                <ItemRow>
                  <ServicesSubSectionTitle>
                    {t('parcel_content_description_label')}
                  </ServicesSubSectionTitle>
                  <ServicesSubSectionValue>
                    {item.description_free}
                  </ServicesSubSectionValue>
                </ItemRow>
              )}
            </Items>
          </List>
        ))}
      </ServicesSubSectionMainContent>
    </ServicesSubSectionContainer>
  );
};

export default observer(ParcelContentSummary);
